import LeftSider from './container/index';

export default LeftSider;



// WEBPACK FOOTER //
// ./src/views/ReportSetup/components/LeftSider/index.js